module.exports = __webpack_public_path__ + "static/img/techs5.fb7a9412.png";